import { useEffect } from 'react';

export function CDPTracker({email, mobile, C4CID, lastName, clusterCode = "", projectName = ""}) {
    useEffect(() => {
        const productID = projectName.toUpperCase().replace(/\s+/g, '_');
        const script = document.createElement('script');
        if(email && mobile && C4CID && lastName && clusterCode && projectName){
            // Load the Gigya CDP script
            script.src = 'https://cdns.cdp.gigya.com/websdk.js';
            script.async = true;
            
            script.onload = () => {
            // Initialize CDP after script loads
                if (window.gigya?.cdp?.init) {
                    window.CDP = null;
                    
                    window.gigya.cdp.init({
                        apiDomain: 'EU5',
                        bUnitId: process.env.CDP_BUNITID,
                        appId: process.env.CDP_APPID
                    })
                    .then(function(sdk) {
                        window.CDP = sdk;
                        sdk.report('WebEvents', {
                            "eventName": "Pencarian Properti di Website",
                            "eventDescription": `Customer sedang melihat properti ${projectName} di Website BSD City`,
                            "email": email,
                            "URLPath": window.location.href,
                            "ClusterCode": clusterCode,
                            "FQDN": "bsdcity.com",
                            "ProductID": productID,
                            "mobile": mobile,
                            "LastName": lastName,
                            "C4CID": C4CID
                        });
                    })
                    .catch(function(error) {
                        console.error('CDP initialization failed:', error);
                    });
                }
            };
            
            script.onerror = () => {
                console.error('Failed to load Gigya CDP script');
            };
            
            document.head.appendChild(script);
            
        }
        
        // Cleanup function to remove script when component unmounts
        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, [email, mobile, C4CID, clusterCode, projectName, lastName]); // Empty dependency array means this runs once on mount
    
    return null; // This component doesn't render anything
};
